import { useState } from 'react';
import FlatIcon from './FlatIcon';

// Map accordion label prefix → flat icon name
const LABEL_ICON = {
  '🎯': 'target',   '🔍': 'search',  '✏️': 'edit',  '✏': 'edit',
  '📈': 'trending_up', '💬': 'chat',  '💡': 'lightbulb',
  '💼': 'work',     '🚀': 'rocket',  '⚡': 'bolt',   '💰': 'monetization',
  '✅': 'check_circle', '📊': 'bar_chart', '🎨': 'palette',
};

function getIcon(label) {
  for (const [emoji, icon] of Object.entries(LABEL_ICON)) {
    if (label.startsWith(emoji)) return icon;
  }
  return 'info';
}

function stripEmoji(label) {
  return label.replace(/^[\u{1F300}-\u{1FFFF}\u{2600}-\u{27BF}\u2600-\u27BF✏️✏⚡✅✓]+\s*/u, '');
}

export default function Accordion({ label, accent, children }) {
  const [open, setOpen] = useState(false);
  const iconName = getIcon(label);
  const cleanLabel = stripEmoji(label);

  return (
    <div style={{ borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%', display: 'flex', alignItems: 'center',
          gap: '0.6rem', padding: '1rem 3rem',
          background: 'none', border: 'none', cursor: 'pointer',
          textAlign: 'left',
        }}
      >
        <FlatIcon name={iconName} size={16} color={accent} style={{ opacity: 0.85, flexShrink: 0 }} />
        <span style={{
          flex: 1, fontSize: '0.72rem', fontFamily: "'DM Mono', monospace",
          letterSpacing: '0.08em', color: accent, textTransform: 'uppercase', fontWeight: 600,
        }}>
          {cleanLabel}
        </span>
        <FlatIcon name={open ? 'remove' : 'add'} size={18} color={accent} />
      </button>
      <div style={{
        overflow: 'hidden', maxHeight: open ? '9999px' : '0',
        opacity: open ? 1 : 0, transition: 'max-height 0.4s ease, opacity 0.3s ease',
      }}>
        {children}
      </div>
    </div>
  );
}
